import Vue from 'vue';
import Router from 'vue-router';
import AccountRoute from '../modules/account/route';
import DashboardRoute from '../modules/dashboard/route';
import Errors from '../modules/errors/route';
import Config from '../modules/config/route';
import Error404 from '../modules/errors/pages/error-404.vue';

Vue.use(Router);

export function GetRoutes() {
  return [
    {
      path: '/',
      redirect: { name: 'dashboard_index' },
    },
    AccountRoute,
    DashboardRoute,
    Config,
    Errors,
    {
      path: '*',
      props: true,
      component: Error404,
    },
  ];
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: GetRoutes(),
});
